// src/pages/LegacyManifestationRedirect.tsx
// 旧 /manifestation/:KANRI_ID → 新 /book/:rl_book_id へのリダイレクト

import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { NEW_API } from '../config/api';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import { useAppTokens } from '../context/ThemeModeContext';

const LegacyManifestationRedirect: React.FC = () => {
  const { KANRI_ID } = useParams<{ KANRI_ID: string }>();
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);
  const TOKENS = useAppTokens();

  useEffect(() => {
    const redirect = async () => {
      if (!KANRI_ID) {
        setError('KANRI_ID が指定されていません');
        return;
      }

      try {
        // ISBN_FETCH API を使って KANRI_ID → rl_book_id を解決
        // Backend 側で ndl_bib_id から rl_book_id を引ける想定
        const response = await axios.get(
          `${NEW_API.BIB_SIMPLE}/resolve/kanri/${KANRI_ID}`
        );
        const rlBookId = response.data?.rl_book_id;
        if (rlBookId) {
          navigate(`/book/${rlBookId}`, { replace: true });
        } else {
          setError('書籍が見つかりませんでした');
        }
      } catch (err) {
        console.error('Failed to resolve KANRI_ID:', err);
        setError('リダイレクトに失敗しました');
      }
    };

    redirect();
  }, [KANRI_ID, navigate]);

  return (
    <Box
      sx={{
        width: '100vw',
        minHeight: '100dvh',
        background: TOKENS.bg,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: TOKENS.text,
      }}
    >
      {error ? (
        <Typography sx={{ fontSize: 13 }}>{error}</Typography>
      ) : (
        <CircularProgress />
      )}
    </Box>
  );
};

export default LegacyManifestationRedirect;
